import { StarIcon } from '@heroicons/react/24/solid'
import { StarIcon as StarOutlineIcon } from '@heroicons/react/24/outline'

export function RatingStars({ rating, outOf = 5, size = 5 }: { rating: number; outOf?: number, size?: number }) {
  if (rating <= 0 || rating > outOf) {
    return <></>
  }
  const fullStars = Math.floor(rating)
  const hasHalf = rating - fullStars >= 0.25 && rating - fullStars < 0.75
  const emptyStars = outOf - fullStars - (hasHalf ? 1 : 0)

  return (
    <div className='flex items-cente mb-0.5'>
      {[...Array(fullStars)].map((_, i) => (
        <StarIcon key={`full-${i}`} className={`size-${size} text-yellow-500`} />
      ))}
      {hasHalf && (
        <span className={`relative size-${size}`}>
          <StarIcon className={`size-${size} text-yellow-500 absolute left-0 top-0`} style={{ clipPath: 'inset(0 50% 0 0)' }} />
          <StarOutlineIcon className={`size-${size} text-yellow-500 absolute left-0 top-0`} style={{ clipPath: 'inset(0 0 0 50%)' }} />
        </span>
      )}
      {[...Array(emptyStars)].map((_, i) => (
        <StarOutlineIcon key={`empty-${i}`} className={`size-${size} text-yellow-500`} />
      ))}
    </div>
  )
}